import { FiTarget } from "react-icons/fi";
import { MAX_GOALS_PER_YEAR } from "../../utils/constants";

// [UPDATED] PM-17: only the employee adds goals, so the count is no longer "employee and manager together".
export default function GoalQuota({ usage, who = "" }) {
  if (!usage) return null;
  const max = usage.max || MAX_GOALS_PER_YEAR;
  const used = Math.min(usage.used, max);
  const tone = usage.limitReached ? "danger" : usage.remaining === 1 ? "warning" : "success";
  return (
    <div className={`goal-quota is-${tone}`} role="status">
      <div className="goal-quota-head">
        <span className="goal-quota-count">
          <FiTarget size={14} aria-hidden="true" /> <strong>{usage.used}</strong> of {max} goals used for {usage.yearLabel || "this year"}
        </span>
        <span className="goal-quota-msg">
          {usage.limitReached
            ? `${max} goals have already been added for the year. No more goals can be added.`
            : `${usage.remaining} more goal${usage.remaining === 1 ? "" : "s"} can be added${who ? ` by ${who}` : ""}.`}
        </span>
      </div>
      <div className="goal-quota-slots" aria-hidden="true">
        {Array.from({ length: max }, (_, i) => <span key={i} className={`goal-quota-slot ${i < used ? "is-used" : ""}`} />)}
      </div>
    </div>
  );
}
